import { render, staticRenderFns } from "./ProductTabTile.vue?vue&type=template&id=0bb352f6&"
import script from "./ProductTabTile.vue?vue&type=script&lang=js&"
export * from "./ProductTabTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports